export enum IIntegrationsPagedFilterEnum {
  SEARCH_BY_NAME = 'query',
  INTEGRATION_TYPE = 'integrationType',
  INTEGRATION_STATUSES = 'statuses',
  AREA_IDS = 'areaIds',
  SCHOOL_IDS = 'schoolIds',
  DISTRICT_IDS = 'districtIds',
}
